import { useUser } from '../../contexts/UserContext';

/**
 * Small KYC status badge derived from the user's kyc_status. Shared by the settings nav and
 * the Profile section (extracted verbatim from AccountSettings's getKycStatusBadge helper).
 */
export function KycStatusBadge({ asText = false }: { asText?: boolean }) {
  const { user } = useUser();
  const status = user?.kyc_status || 'not_started';

  const statusConfig = {
    verified: { color: 'bg-success text-success-foreground', text: 'Verified' },
    active: { color: 'bg-warning-500 text-warning-foreground', text: 'In Progress' },
    pending: { color: 'bg-warning-500 text-warning-foreground', text: 'Pending' },
    in_progress: { color: 'bg-warning-500 text-warning-foreground', text: 'In Progress' },
    pending_review: { color: 'bg-warning-500 text-warning-foreground', text: 'Under Review' },
    failed: { color: 'bg-error-500 text-error-foreground', text: 'Failed' },
    rejected: { color: 'bg-error-500 text-error-foreground', text: 'Failed' },
    expired: { color: 'bg-muted text-muted-foreground', text: 'Expired' },
    not_started: { color: 'bg-muted text-muted-foreground', text: 'Not Started' },
  };

  const config = statusConfig[status as keyof typeof statusConfig] || statusConfig.not_started;

  // Plain-text variant: matches surrounding text rows (e.g. Profile → Account Details) instead of
  // a pill. Subtle status color only; no chip.
  if (asText) {
    const textColor =
      status === 'verified'
        ? 'text-[hsl(var(--success))]'
        : status === 'failed' || status === 'rejected'
          ? 'text-destructive'
          : 'text-foreground';
    return <span className={textColor}>{config.text}</span>;
  }

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
      {config.text}
    </span>
  );
}

export default KycStatusBadge;
